import React from 'react'

import { Box } from '@chakra-ui/react'
import { Route, Routes } from 'react-router'

import { getRelativePath } from '../../../../../../../constants/paths'
import { useTemplateEntities } from '../../template-entities-context'
import { TemplateDetail } from '../detail/template-detail'

type Props = {}

export const List: React.FC<Props> = () => {
  const { fetched } = useTemplateEntities()

  if (!fetched) {
    return null
  }

  return (
    <Box h="full">
      <Routes>
        <Route
          path={`${getRelativePath('Templates', 'Template')}`}
          element={<TemplateDetail />}
        />
      </Routes>
    </Box>
  )
}
